import { Url, CHECKOUT_IDS } from '@wix/da-url';
import { GROUPS_ROLE_ID_FOUNDER } from '@wix/da-shared-react/pkg/utils/constants';

interface Item {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  biData?: any;
}
export const getItems = (
  t,
  {
    pushBadgeModal,
    pushPointsModal,
    leaveGroup,
    closeGroup,
    unwatch,
    onLlamaBadgeSent,
    onCakeBadgeSent,
    profileOwnerUser,
    profileOwnerUser: { username, userId },
    giveState,
    isOwner,
    isGroup,
    extendedGroup,
    pushBlockModal,
    showMobileSharePopup,
    requestJoinGroup,
  }
) => {
  let items: Item[] = [];
  const { isMember, isAdmin, roleId } = extendedGroup || {};
  const isFounder = roleId === GROUPS_ROLE_ID_FOUNDER;
  if (isGroup) {
    return [
      // WATCHERS:
      isMember &&
        !isAdmin && {
          label: t('navigation.subnavigation.messageAdmins'),
          onClick: () => window.location.assign(Url.groupnoteLink(username)),
        },
      isMember &&
        !isAdmin && {
          label: t('navigation.subnavigation.unwatchGroup'),
          onClick: () => unwatch(profileOwnerUser),
        },
      isMember &&
        !isAdmin && {
          label: t('navigation.subnavigation.leaveGroup'),
          onClick: () => leaveGroup(profileOwnerUser),
        },
      // ADMINS:
      isAdmin && {
        label: t('navigation.subnavigation.groupNotifications'),
        onClick: () =>
          window.location.assign(
            Url.groupNotificationsLink(profileOwnerUser.userId)
          ),
      },
      /* We need a new PAPI endpoint
      isAdmin && {
        label: t('navigation.subnavigation.sendInvitation'),
        onClick: () => window.location.assign(Url.groupnoteLink(username)),
      },
      */
      isAdmin && {
        label: t('navigation.subnavigation.leaveGroup'),
        onClick: () => leaveGroup(profileOwnerUser),
      },
      isFounder && {
        label: t('navigation.subnavigation.closeGroup'),
        onClick: () => closeGroup(profileOwnerUser),
      },
      // OTHERS:
      !isMember &&
        !isAdmin && {
          label: t('navigation.subnavigation.messageAdmins'),
          onClick: () => window.location.assign(Url.groupnoteLink(username)),
        },
      !isMember &&
        !isAdmin && {
          label: t('navigation.subnavigation.requestJoin'),
          onClick: () => requestJoinGroup(profileOwnerUser),
        },
    ].filter(Boolean) as Item[];
  }
  if (!isOwner) {
    items = [
      {
        label: giveState.canBeGivenCore
          ? t!('navigation.subnavigation.giveCore')
          : t!('navigation.subnavigation.hasCore'),
        onClick: () => window.location.assign(Url.giveCoreMembership(username)),
        disabled: !giveState.canBeGivenCore,
      },
      {
        label: t!('navigation.subnavigation.givePoints'),
        onClick: () => {
          pushPointsModal(username, t!('navigation.subnavigation.givePoints'));
        },
      },
      {
        label: giveState.canBeGivenLlama
          ? t!('navigation.subnavigation.giveLlamaBadge')
          : t!('navigation.subnavigation.hasGotLlamaBadge'),
        onClick: () => {
          pushBadgeModal(username, onLlamaBadgeSent);
        },
        disabled: !giveState.canBeGivenLlama,
      },
      {
        label: giveState.canBeGivenCake
          ? t!('navigation.subnavigation.giveCakeBadge')
          : t!('navigation.subnavigation.hasGotCakeBadge'),
        onClick: () => {
          window.location.assign(
            `${Url.checkoutLink(CHECKOUT_IDS.CAKE)}&foruserid=${userId}`
          );
        },
        disabled: !giveState.canBeGivenCake,
      },
    ];
  }

  if (!isOwner) {
    items.push({
      label: t('navigation.subnavigation.blockUser'),
      onClick: () => pushBlockModal(profileOwnerUser),
    });
  }

  items.push({
    label: t('navigation.subnavigation.share'),
    onClick: () =>
      showMobileSharePopup(
        Url.userLink(profileOwnerUser.username),
        t('navigation.subnavigation.share.title', profileOwnerUser)
      ),
  });

  return items;
};
